import { RackDto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class RackResponseModel extends GlobalResponseObject{
    data?: RackDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //RackDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RackDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 